/**
 * ============================================================
 * Hungarian
 * ============================================================
 *
 * Translators:
 *
 * Levev <levvevv@gmail.com>
 * TibixDev <fuloptibi03@gmail.com>
 */

export default {
	'AdvanceHelp': 'Ahhoz, hogy tovább haladj a játékban, nyomd meg a bal egérgombot, koppints bárhová a képernyőn, vagy nyomd le a space-t',
	'AllowPlayback': 'Kattints ide hogy engedélyezd a hangvisszajátszást',
	'Audio': 'Hang',
	'AutoPlay': 'Automata',
	'AutoPlayButton': 'Automatikus játék engedélyezése',
	'AutoPlaySpeed': 'Automata játéksebesség',

	'Back': 'Vissza',
	'BackButton': 'Menj vissza',

	'Cancel': 'Mégse',
	'Close': 'Bezár',
	'Confirm': 'Ki akarsz lépni?',
	'Credits': 'Stáblista',

	'Delete': 'Törlés',
	'DialogLogButton': 'Párbeszédnapló megjelenítése',

	'FullScreen': 'Teljesképernyő',

	'Gallery': 'Galéria',

	'Help': 'Segítség',
	'Hide': 'Elrejtés',
	'HideButton': 'Szövegdoboz elrejtése',

	'iOSAudioWarning': 'A hangbeállítások nem támogatottak iOS rendszereken',

	'KeyboardShortcuts': 'Billentyűkombinációk',

	'Language': 'Nyelv',
	'Load': 'Betöltés',
	'LoadAutoSaveSlots': 'Automatikusan elmentett játékmenetek',
	'LoadButton': 'Betöltőképernyő megnyitása',
	'Loading': 'Betöltés',
	'LoadingMessage': 'Várj, amíg az erőforrások betöltenek',
	'LoadSlots': 'Mentett Játékmenetek',
	'LocalStorageWarning': 'A Lokális Tárhely nem található ebben a keresőben',
	'Log': 'Napló',

	'Music': 'Zene Hangereje',

	'NewContent': 'Új tartalom elérhető, frissítsd az oldalt a legújabb verzióért',
	'NoSavedGames': 'Nem található mentett játékmenet',
	'NoAutoSavedGames': 'Nem található automatikusan mentett játékmenet',
	'NoDialogsAvailable': 'Nem található párbeszéd. A párbeszédek itt fognak megjelenni amint találkozol velük',

	'OK': 'Oké',
	'OrientationWarning': 'Kérlek, fordítsd el az eszközöd a játékhoz',
	'Overwrite': 'Felülírás',

	'QuickButtons': 'Gyorsmenü gombok',
	'QuickMenu': 'Gyorsmenü',
	'Quit': 'Kilépés',
	'QuitButton': 'Kilépés a játékból',

	'Resolution': 'Felbontás',

	'Save': 'Mentés',
	'SaveButton': 'Mentések megnyitása',
	'SaveInSlot': 'Slotba mentés',
	'SelectYourLanguage': 'Nyelved kiválasztása',
	'Settings': 'Beállítások',
	'SettingsButton': 'Beállítások megnyitása',
	'Show': 'Mutasd',
	'Skip': 'Kihagyás',
	'SkipButton': 'Kihagyás-mód bekapcsolása',
	'SlotDeletion': 'Biztosan ki akarod törölni ezt a slot-ot?',
	'SlotOverwrite': 'Biztosan felül akarod írni ezt a slot-ot?',
	'Sound': 'Hangerő',
	'Start': 'Start',
	'Stop': 'Stop',

	'TextSpeed': 'Szöveg Sebessége',

	'Video': 'Videó Hangereje',
	'Voice': 'Beszéd Hangereje',

	'Windowed': 'Ablakozott'
};